import { Box, Container, Flex, Grid, GridItem, Heading, Link, SimpleGrid, Spacer, Text, Image, Tabs, Center, TabList, TabPanels, TabPanel, Tab, Button } from "@chakra-ui/react";
import React from "react";
import parser from "html-react-parser";
import Slider from "react-slick";

const SlidesBlock = ({ page, block }) => {

    const settingsSlick = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 8000,
    };

    return (
        <Box mb={'-10px'}>
            <Slider {...settingsSlick} className="guide-slider">

                {block.entry.slides?.map((slide, index) => (
                    <div>
                        <SimpleGrid columns={{ base: 1, md: 2 }}>
                            <Box pt="50px" pb="50px" pl={{ base: '20px', md: "150px" }} pr={{ base: '20px', md: "100px" }} bg="white" textAlign="left">
                                {slide.top_title != null && (
                                    <Button as={Link} href={slide.top_link} bg="#D51F0C" color="white" fontSize="12px" marginTop="20px" letterSpacing="2px" borderTopStartRadius={20} borderBottomStartRadius={20} borderTopEndRadius={20} borderBottomEndRadius={20}>{slide.top_title}</Button>
                                )}
                                {slide.title != null && (
                                    <Heading fontSize="7xl" textAlign="left" lineHeight={0.8} color="#143B49" mt={5}>
                                        {slide.title}
                                    </Heading>
                                )}
                                {slide.content != null && (
                                    <Box>{parser(slide.content)}</Box>
                                )}
                                {slide.link != null && (
                                    <Button as={Link} href={slide.link} bg="#D51F0C" color="white" fontSize="12px" marginTop="10px" letterSpacing="2px" borderTopStartRadius={20} borderBottomStartRadius={20} borderTopEndRadius={20} borderBottomEndRadius={20}>{slide.button_text}</Button>
                                )}
                            </Box>
                            {slide.img != null && (
                                <Box backgroundImage={`url(${slide.img})`} backgroundPosition="center center" backgroundRepeat="no-repeat" backgroundSize="cover" minHeight="550px">

                                </Box>
                            )}
                        </SimpleGrid>
                    </div>
                ))}

            </Slider>

        </Box>
    )
};

export default SlidesBlock;